export default {
  name: 'Dropdown',

  props: {
    openDefault: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      open: false
    }
  },

  created() {
    this.open = this.openDefault
  }
}